import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'

import AddressEnrollmentForm from './address-enrollment-form'
import ChildAloneEnrollmentForm from './child-alone-enrollment-form'
import ChildInformationEnrollmentForm from './child-information-enrollment-form'
import ContactEnrollmentForm from './contact-enrollment-form'
import FriendsEnrollmentForm from './friends-enrollment-form'
import HealthInformationEnrollmentForm from './health-information-enrollment-form'
import HowDidYouHearAboutUsEnrollmentForm from './how-did-you-hear-about-us-enrollment-form'
import ParentsInformationEnrollmentForm from './parents-information-enrollment-form'

type Props = {
  mode: 'create' | 'edit'
  enrollmentId?: number
  cseCode?: string | null
  canGoOutAloneOption: boolean
  departureDate?: string
  canEditMainMedicalInformations?: boolean
}

const EnrollmentInformationForm = ({
  mode,
  enrollmentId,
  cseCode,
  canGoOutAloneOption,
  departureDate,
  canEditMainMedicalInformations
}: Props) => {
  return (
    <div id="enrollment-informations">
      <InnerBox
        title="Informations "
        titleColor={tailwindColors.black.DEFAULT}
        className="p-5 rounded-2xl"
      >
        <div className="flex justify-between gap-3">
          <div className="flex-1 flex flex-col gap-3">
            <InnerBox title="Informations sur le participant" className="rounded-2xl">
              <ChildInformationEnrollmentForm
                enrollmentId={enrollmentId}
                departureDate={departureDate}
              />
            </InnerBox>
            <HealthInformationEnrollmentForm
              mode={mode}
              canEditMainMedicalInformations={canEditMainMedicalInformations}
            />
            {canGoOutAloneOption && <ChildAloneEnrollmentForm />}
            <FriendsEnrollmentForm />
          </div>
          <div className="flex-1 flex flex-col gap-3">
            <InnerBox title="Informations sur les parents" className="rounded-2xl">
              <ParentsInformationEnrollmentForm enrollmentId={enrollmentId} cseCode={cseCode} />
            </InnerBox>
            <InnerBox title="Adresse du contact prioritaire" className="rounded-2xl">
              <AddressEnrollmentForm />
            </InnerBox>
            <InnerBox title="Contact en cas d’urgence" className="rounded-2xl">
              <ContactEnrollmentForm />
            </InnerBox>
            <HowDidYouHearAboutUsEnrollmentForm />
          </div>
        </div>
      </InnerBox>
    </div>
  )
}

export default EnrollmentInformationForm
